import { useEffect, useState } from "react";

import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import theme from "@theme/index";

interface ISignupSuccessProperties {
  email: string;
}

const SignupSuccess = ({ email }: ISignupSuccessProperties) => {
  const [wasResent, setWasResent] = useState(false);
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((previousCount) => {
        if (previousCount <= 1) {
          clearInterval(timer);
          setWasResent(false);
          return 0;
        }
        return previousCount - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleResendEmail = () => {
    if (countdown > 0) return;
    try {
      setWasResent(true);
    } catch {
      setCountdown(0);
    }
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 4,
        justifyContent: "center",
        overflowY: "auto",
        p: {
          sm: 4,
          xs: 2,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: "unset",
          height: "fit-content",
          overflow: "visible",

          width: {
            sm: "700px",
            xs: "95%",
          },
        }}
      >
        <Typography align="center" variant="h3">
          Account Created
        </Typography>
        <Typography align="center" sx={{ mt: 3 }} variant="body1">
          You have entered <b>{email}</b> as the email address for your account.
        </Typography>
        <Typography align="center" sx={{ mt: 3 }} variant="body1">
          Please check your inbox for your verification email.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          {!wasResent && (
            <Button
              disabled={countdown > 0}
              onClick={!wasResent && countdown === 0 ? handleResendEmail : undefined}
              variant="contained"
            >
              {!wasResent && countdown === 0
                ? "Resend Verification Email"
                : countdown > 0
                  ? `Resend available in ${countdown}s`
                  : "Email Sent"}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default SignupSuccess;
